import React, { Component } from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  contentFormat: {
    textAlign: "left",
    marginLeft: 10,
  },
});

class RecentMessageResultRow extends Component {
  render() {
    const { message, classes } = this.props;
    const sentDate = message.DateSent.split(" ");
    const readDate = message.DateRead.split(" ");
    return (
      <TableRow>
        <TableCell padding="none">{message.Agent}</TableCell>
        <TableCell padding="none">{message.Player}</TableCell>
        <TableCell padding="none">
          {message.FromAgent === "0" ? "No" : "Yes"}
        </TableCell>
        <TableCell padding="none">
          <div className={classes.contentFormat}>{message.Content}</div>
        </TableCell>
        <TableCell padding="none">
          {sentDate[0]} <br />
          {sentDate[1]}
        </TableCell>
        <TableCell padding="none">
          {readDate[0]} <br />
          {readDate[1]}
        </TableCell>
      </TableRow>
    );
  }
}

RecentMessageResultRow.propTypes = {
  message: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(RecentMessageResultRow);
